import { PropsWithChildren } from "react";
import { AuthContext } from "../hooks/use-auth-context";
import { useAuthSession } from "../hooks/use-auth-session";

export default function AuthProvider({ children }: PropsWithChildren) {
  const auth = useAuthSession();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
